import { supabase } from "@/lib/supabase"
import type { AuditLog } from "@/types"

export async function getAuditLog(limit = 50, actionType?: string): Promise<AuditLog[]> {
  let query = supabase
    .from("audit_log")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(limit)

  if (actionType && actionType !== "all") {
    query = query.eq("action_type", actionType)
  }

  const { data, error } = await query
  if (error) throw error
  return (data ?? []) as AuditLog[]
}

export function getActivityIcon(actionType: string): string {
  const map: Record<string, string> = {
    email_change:       "📧",
    password_reset:     "🔑",
    user_suspended:     "🚫",
    user_unsuspended:   "✅",
    slot_takeover:      "🏢",
    ownership_transfer: "🔄",
    commission_adjustment: "✏️",
    reminder_sent:      "📨",
    announcement_sent:  "📢",
    payout_approved:    "💸",
    w9_approved:        "📋",
    bank_verified:      "🏦",
  }
  return map[actionType] ?? "📌"
}

export function timeAgo(dateStr: string): string {
  const seconds = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000)
  if (seconds < 60)    return `${seconds}s ago`
  if (seconds < 3600)  return `${Math.floor(seconds / 60)}m ago`
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`
  if (seconds < 2592000) return `${Math.floor(seconds / 86400)}d ago`
  return new Date(dateStr).toLocaleDateString()
}